// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//   setProceedLoading(true)
//   const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//   console.log("data", data)
//   if (data.resendOtp) {
//     console.log("Resend OTP event detected.");
//   }

//   console.log("Responsedata", responsedata)

//   // ── NEW: handle the dict-shaped responses (otp-verified / googleId-verified) ──
//   if (responsedata?.status === "otp-verified" || responsedata?.status === "googleId-verified") {
//     localStorage.removeItem("plivo_session_uid")
//     localStorage.setItem('authToken', responsedata.SecretKey)
//     localStorage.setItem('lastLoginTime', Date.now())
//     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//     navigate("/codomo/home")
//     setProceedLoading(false)
//     setUsedGoogle(false)
//     return
//   }

//   // ── EXISTING: old string/tuple-shaped responses (unchanged) ──────────────────
//   const session_uuid = responsedata[1]
//     localStorage.setItem("session_uuid", session_uuid);
//     if (responsedata[0] === "user-verified") {
//       const session_uuid = responsedata[1]
//       localStorage.setItem("plivo_session_uid", session_uuid)
//     }
//     if (responsedata[0] === "user-verified") { setShowOtpColoumn(responsedata) }
//     else if (responsedata === "user-verified") { setShowOtpColoumn(responsedata) }
//     else if (responsedata === "otp-verification-failed") { notify("Otp Verification Failed") }
//     else if (responsedata === "user-not-active") { notify("User is not Active") }
//     else if (responsedata === "user-verification-failed") { notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform."); navigate('/signUp') }
//     else if (responsedata === "otp-expired") { notify("Otp is Expired") }
//     else if (responsedata[0] === "email-verification-pending") {
//       notify("Please Verify Your Mail")
//       localStorage.setItem('UserKey', JSON.stringify(responsedata[1])); navigate('/confirmemail')
//     }
//     else if (responsedata === "user-verified") {
//       localStorage.setItem('authToken', responsedata[2]); localStorage.setItem('lastLoginTime', Date.now()); navigate("/codomo/home")
//       localStorage.setItem('UserKey', JSON.stringify(responsedata[1]))
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }
//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;

















// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     setUsedGoogle(true)
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);


//   // In SignIn.jsx - Fix the FetchData function:

// const FetchData = async (data) => {
//   setProceedLoading(true);
//   try {
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data);
//     console.log("Responsedata", responsedata);

//     const status = responsedata?.status;

//     if (status === "otp-verified" || status === "googleId-verified") {
//       // Save session data
//       localStorage.removeItem("plivo_session_uid");
//       localStorage.setItem('authToken', responsedata.SecretKey);
//       localStorage.setItem('lastLoginTime', Date.now().toString());
//       localStorage.setItem('UserKey', JSON.stringify(responsedata.user));
      
//       // Clear any previous state
//       setShowOtpColoumn(false);
      
//       // Navigate to home
//       window.location.href = "/codomo/home";
//       // navigate("/codomo/home");
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true);
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed");
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active");
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.");
//       navigate('/signUp');
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired");
//     }
//     else if (status === "email-verification-pending") {
//       notify("Please Verify Your Mail");
//       if (responsedata.user) {
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user));
//       }
//       navigate('/confirmemail');
//     }
//     else if (status === "payment-pending") {
//       notify(responsedata.message || "Please complete your course payment to sign in.");
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(responsedata?.message || "Something went wrong. Please try again.");
//     }
//   } catch (error) {
//     console.error("SignIn error:", error);
//     notify("Something went wrong. Please try again.");
//   } finally {
//     setProceedLoading(false);
//     setUsedGoogle(false);
//   }
// };

//   // const FetchData = async (data) => {
//   //   setProceedLoading(true)
//   //   const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//   //   console.log("data", data)
//   //   if (data.resendOtp) {
//   //     console.log("Resend OTP event detected.");
//   //   }

//   //   console.log("Responsedata", responsedata)

//   //   const status = responsedata?.status

//   //   if (status === "otp-verified" || status === "googleId-verified") {
//   //     localStorage.removeItem("plivo_session_uid")
//   //     localStorage.setItem('authToken', responsedata.SecretKey)
//   //     localStorage.setItem('lastLoginTime', Date.now())
//   //     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//   //     navigate("/codomo/home")
//   //   }
//   //   else if (status === "user-verified") {
//   //     setShowOtpColoumn(true)
//   //   }
//   //   else if (status === "otp-verification-failed") {
//   //     notify("Otp Verification Failed")
//   //   }
//   //   else if (status === "user-not-active") {
//   //     notify("User is not Active")
//   //   }
//   //   else if (status === "user-verification-failed") {
//   //     notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.")
//   //     navigate('/signUp')
//   //   }
//   //   else if (status === "otp-expired") {
//   //     notify("Otp is Expired")
//   //   }
//   //   else if (status === "email-verification-pending") {
//   //     notify("Please Verify Your Mail")
//   //     if (responsedata.user) {
//   //       localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//   //     }
//   //     navigate('/confirmemail')
//   //   }
//   //   else if (status === "payment-pending") {
//   //     notify(responsedata.message || "Please complete your course payment to sign in.")
//   //   }
//   //   else if (status === "otp_sending_failed" || status === "server-error") {
//   //     notify(responsedata?.message || "Something went wrong. Please try again.")
//   //   }

//   //   setProceedLoading(false)
//   //   setUsedGoogle(false)
//   // }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;



































// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)

//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });

//   // ── Google Sign-In ──────────────────────────────────────────────────────
//   // BUG: this was previously wired to `fetchdatafromgoogleapis`, a function
//   // that was referenced here but never defined anywhere in the file. Every
//   // successful Google login threw a ReferenceError the moment onSuccess
//   // fired, before CheckUserDetailsForSignIn was ever called. Implemented
//   // below: exchange the access_token for the Google profile, then forward
//   // {emailOrPhone, googleId} to FetchData exactly like the OTP flow does.
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     setUsedGoogle(true)
//     try {
//       const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` },
//       });
//       if (!res.ok) throw new Error(`Google userinfo request failed (${res.status})`);
//       const profile = await res.json();

//       if (!profile.email || !profile.sub) {
//         notify("Could not read your Google account details. Please try again.");
//         setUsedGoogle(false);
//         return;
//       }

//       await FetchData({
//         emailOrPhone: profile.email.trim().toLowerCase(),
//         googleId: profile.sub,
//       });
//     } catch (err) {
//       console.error("Google sign-in failed:", err);
//       notify("Google sign-in failed. Please try again.");
//       setUsedGoogle(false);
//     }
//   };

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => {
//       console.log('Login Failed:', error);
//       notify("Google sign-in failed. Please try again.");
//     }
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   // ── Submit handler — used for both the initial OTP request and OTP verify ──
//   // `data` is forwarded as-is to CheckUserDetailsForSignIn, so it must match
//   // the Lambda's expected payload shape exactly:
//   //   step 1 (send OTP):    { emailOrPhone }
//   //   step 2 (verify OTP):  { emailOrPhone, user_otp }
//   //   google sign-in:       { emailOrPhone, googleId }
//   const FetchData = async (data) => {
//     setProceedLoading(true)
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//     console.log("Responsedata", responsedata)

//     // The Lambda always returns a plain object: { status, ...extra }.
//     // (Older code here also handled tuple/array-shaped and bare-string
//     // responses from a previous version of the Lambda — that version no
//     // longer exists, so those dead branches have been removed.)
//     const status = responsedata?.status;

//     switch (status) {
//       case "otp-verified":
//       case "googleId-verified": {
//         localStorage.removeItem("plivo_session_uid")
//         localStorage.setItem('authToken', responsedata.SecretKey)
//         localStorage.setItem('lastLoginTime', Date.now())
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//         navigate("/codomo/home")
//         break;
//       }

//       case "user-verified": {
//         // OTP has been sent — reveal the OTP entry step.
//         setShowOtpColoumn(true)
//         break;
//       }

//       case "otp-verification-failed": {
//         notify("Otp Verification Failed")
//         break;
//       }

//       case "otp-expired": {
//         notify("Otp is Expired")
//         break;
//       }

//       case "user-not-active": {
//         notify("User is not Active")
//         break;
//       }

//       case "email-verification-pending": {
//         notify("Please Verify Your Mail")
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user ?? { emailOrPhone: data.emailOrPhone }))
//         navigate('/confirmemail')
//         break;
//       }

//       case "user-verification-failed": {
//         notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.")
//         navigate('/signUp')
//         break;
//       }

//       case "payment-pending": {
//         notify(responsedata.message || "Please complete your course payment to sign in.")
//         break;
//       }

//       case "otp_sending_failed":
//       case "server-error": {
//         notify(responsedata.message || "Something went wrong. Please try again.")
//         break;
//       }

//       default: {
//         notify("Something went wrong. Please try again.")
//       }
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;

























// import React, { useEffect, useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { useGoogleLogin } from '@react-oauth/google';
// import SignInForm from "./SignInForm";
// import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
// import { CheckUserDetailsForSignIn } from '../../api/aws-api';
// import { toast } from 'react-toastify';
// import axios from 'axios';


// function SignIn(props) {
//   const navigate = useNavigate()
//   const [showOtpColoumn, setShowOtpColoumn] = useState(false)
//   const [proceedLoading, setProceedLoading] = useState(false)
//   const [usedGoogle, setUsedGoogle] = useState(false)


//   const notify = (message) => toast.error(message, {
//     className: 'my-custom-toast',
//     position: "top-left",
//     autoClose: 10000,
//     hideProgressBar: false,
//     pauseOnHover: true,
//     progress: undefined,
//     theme: "light",
//   });;
//   const fetchdatafromgoogleapis = async (codeResponse) => {
//     setUsedGoogle(true)
//     try {
//       const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
//         headers: { Authorization: `Bearer ${codeResponse.access_token}` }
//       })
//       const email = res.data.email
//       const googleId = res.data.sub
//       await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
//     } catch (error) {
//       console.error(error)
//       notify('Google Sign-In Failed. Please try again.')
//       setUsedGoogle(false)
//     }
//   }

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
//     onError: (error) => console.log('Login Failed:', error)
//   });

//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//   }, []);

//   const FetchData = async (data) => {
//     setProceedLoading(true)
//     const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
//     console.log("data", data)
//     if (data.resendOtp) {
//       console.log("Resend OTP event detected.");
//     }

//     console.log("Responsedata", responsedata)

//     const status = responsedata?.status

//     if (status === "otp-verified" || status === "googleId-verified") {
//       localStorage.removeItem("plivo_session_uid")
//       localStorage.setItem('authToken', responsedata.SecretKey)
//       localStorage.setItem('lastLoginTime', Date.now())
//       localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       navigate("/codomo/home")
//     }
//     else if (status === "user-verified") {
//       setShowOtpColoumn(true)
//     }
//     else if (status === "otp-verification-failed") {
//       notify("Otp Verification Failed")
//     }
//     else if (status === "user-not-active") {
//       notify("User is not Active")
//     }
//     else if (status === "user-verification-failed") {
//       notify("Sorry, it looks like we can't find your account! Click 'let's get started' to join our platform.")
//       navigate('/signUp')
//     }
//     else if (status === "otp-expired") {
//       notify("Otp is Expired")
//     }
//     else if (status === "email-verification-pending") {
//       notify("Please Verify Your Mail")
//       if (responsedata.user) {
//         localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
//       }
//       navigate('/confirmemail')
//     }
//     else if (status === "payment-pending") {
//       notify(responsedata.message || "Please complete your course payment to sign in.")
//     }
//     else if (status === "otp_sending_failed" || status === "server-error") {
//       notify(responsedata?.message || "Something went wrong. Please try again.")
//     }

//     setProceedLoading(false)
//     setUsedGoogle(false)
//   }

//   return (
//     <>
//       <SignInForm GoogleLoginFunction={login} FetchData={FetchData}
//         showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
//         setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
//       />
//     </>
//   );
// }

// export default SignIn;






















import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { useGoogleLogin } from '@react-oauth/google';
import SignInForm from "./SignInForm";
import { ConstructorEventPost, ConstructorEventGetNoParams } from '../../Event/event';
import { CheckUserDetailsForSignIn } from '../../api/aws-api';
import { toast } from 'react-toastify';
import axios from 'axios';


function SignIn(props) {
  const navigate = useNavigate()
  const [showOtpColoumn, setShowOtpColoumn] = useState(false)
  const [proceedLoading, setProceedLoading] = useState(false)
  const [usedGoogle, setUsedGoogle] = useState(false)


  const notify = (message) => toast.error(message, {
    className: 'my-custom-toast',
    position: "top-left",
    autoClose: 10000,
    hideProgressBar: false,
    pauseOnHover: true,
    progress: undefined,
    theme: "light",
  });;
  const fetchdatafromgoogleapis = async (codeResponse) => {
    try {
      const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${codeResponse.access_token}` }
      })
      const email = res.data.email
      const googleId = res.data.sub
      await FetchData({ emailOrPhone: email.toLowerCase(), googleId })
    } catch (error) {
      console.error(error)
      notify('Google Sign-In Failed. Please try again.')
      setUsedGoogle(false)
    }
  }

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => fetchdatafromgoogleapis(codeResponse),
    onError: (error) => {
      console.log('Login Failed:', error);
      setUsedGoogle(false);
    }
  });

  // Guards the window between the click and the OAuth popup resolving.
  // usedGoogle previously only flipped true inside fetchdatafromgoogleapis
  // (after the popup closed), leaving the button clickable while the
  // popup was open — a second click there fired a second sign-in flow,
  // each overwriting the DB's SecretKey and racing with the other's
  // response, which is what caused intermittent authentication_failed.
  const handleGoogleLogin = () => {
    if (usedGoogle) return;
    setUsedGoogle(true);
    login();
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  const FetchData = async (data) => {
    setProceedLoading(true)
    const responsedata = await ConstructorEventPost(CheckUserDetailsForSignIn, data)
    console.log("data", data)
    if (data.resendOtp) {
      console.log("Resend OTP event detected.");
    }

    console.log("Responsedata", responsedata)

    const status = responsedata?.status

    if (status === "otp-verified" || status === "googleId-verified") {
      localStorage.removeItem("plivo_session_uid")
      localStorage.setItem('authToken', responsedata.SecretKey)
      localStorage.setItem('lastLoginTime', Date.now())
      localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
      navigate("/codomo/home")
    }
    else if (status === "user-verified") {
      setShowOtpColoumn(true)
    }
    else if (status === "otp-verification-failed") {
      notify("Otp Verification Failed")
    }
    else if (status === "user-not-active") {
      notify("User is not Active")
    }
    else if (status === "user-verification-failed") {
      notify("Sorry, it looks like we can't find your account!")
      // navigate('/signUp')
    }
    else if (status === "otp-expired") {
      notify("Otp is Expired")
    }
    // else if (status === "email-verification-pending") {
    //   notify("Please Verify Your Mail")
    //   if (responsedata.user) {
    //     localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
    //   }
    //   // navigate('/confirmemail')
    // }
    else if (status === "email-verification-pending") {
      notify("Sorry, it looks like we can't find your account!")
      if (responsedata.user) {
        localStorage.setItem('UserKey', JSON.stringify(responsedata.user))
      }
      // navigate('/confirmemail')
    }
    else if (status === "payment-pending") {
      notify(responsedata.message || "Please complete your course payment to sign in.")
    }
    else if (status === "otp_sending_failed" || status === "server-error") {
      notify(responsedata?.message || "Something went wrong. Please try again.")
    }

    setProceedLoading(false)
    setUsedGoogle(false)
  }

  return (
    <>
      <SignInForm GoogleLoginFunction={handleGoogleLogin} FetchData={FetchData}
        showOtpColoumn={showOtpColoumn} proceedLoading={proceedLoading}
        setShowOtpColoumn={setShowOtpColoumn} usedGoogle={usedGoogle}
      />
    </>
  );
}

export default SignIn;